(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /*
   * Joven — hover menüsü hizalama motoru.
   * Panelin içeren bloğu header satırıdır (bkz. stylesheet'teki not: menü
   * öğeleri overflow-list'in shadow DOM'unda kırpılan bir kutuda duruyor),
   * bu yüzden "hover edilen öğenin altında" hizası JS ile hesaplanır:
   *   --jhm-left      panelin satır içindeki sol ofseti (öğeyle hizalı)
   *   --jhm-max-width sayfa sütunu genişliği (panel bundan geniş olamaz)
   * Panel sağ kenardan taşarsa sola kaydırılır, asla sayfa sütununu aşmaz.
   */
  (function () {
    if (window.__jovenHeaderMenuAlign) return;
    window.__jovenHeaderMenuAlign = true;

    var PANEL = '.menu-list__list-item:not([slot="overflow"]) > .menu-list__submenu';

    function columnBounds(header) {
      var col = header.querySelector('.header__row--bottom .header__columns') ||
                header.querySelector('.header__columns');
      if (col) {
        var c = col.getBoundingClientRect();
        if (c.width > 0) return { left: c.left, right: c.right };
      }
      var h = header.getBoundingClientRect();
      return { left: h.left + 16, right: h.right - 16 };
    }

    /* Panelin üst kenarı tetikleyici öğenin alt kenarına birebir oturur
       (ölü bölge = hover kopması yok), kart ise header'ın altında CARD_GAP
       kadar aşağıda başlar. */
    var CARD_GAP = 8;

    function verticalOffsets(triggerRect, header, offsetParent) {
      var parentTop = offsetParent.getBoundingClientRect().top;
      var headerBottom = header.getBoundingClientRect().bottom;
      var top = triggerRect.bottom - parentTop;
      var offset = Math.max(0, headerBottom + CARD_GAP - triggerRect.bottom);
      return { top: Math.round(top), offset: Math.round(offset) };
    }

    function align(panel) {
      var li = panel.parentElement;
      var header = panel.closest('#header-component');
      var offsetParent = panel.offsetParent;
      if (!li || !header || !offsetParent) return;

      var bounds = columnBounds(header);
      var maxWidth = Math.max(240, bounds.right - bounds.left);
      panel.style.setProperty('--jhm-max-width', maxWidth + 'px');

      // Ölçüm sırasında eski kaydırmanın etkisi olmasın.
      panel.style.setProperty('--jhm-left', '0px');
      var width = panel.getBoundingClientRect().width;
      var itemRect = li.getBoundingClientRect();

      var left = itemRect.left;
      if (left + width > bounds.right) left = bounds.right - width;
      if (left < bounds.left) left = bounds.left;

      panel.style.setProperty('--jhm-left', Math.round(left - offsetParent.getBoundingClientRect().left) + 'px');

      var v = verticalOffsets(itemRect, header, offsetParent);
      panel.style.setProperty('--jhm-top', v.top + 'px');
      panel.style.setProperty('--jhm-offset', v.offset + 'px');
    }

    /* "DİĞER" paneli de aynı kurala uyar: tetikleyici öğenin sol kenarıyla
       hizalanır, sayfa sütununu taşarsa sola kaydırılır. */
    function alignOverflow() {
      var overflow = document.querySelector('.overflow-menu');
      if (!overflow) return;
      var header = overflow.closest('#header-component');
      var more = overflow.querySelector('[slot="more"]');
      if (!header || !more) return;

      var bounds = columnBounds(header);
      var maxWidth = Math.max(240, bounds.right - bounds.left);
      overflow.style.setProperty('--jhm-max-width', maxWidth + 'px');

      var moreRect = more.getBoundingClientRect();
      if (!moreRect.width) return;

      overflow.style.setProperty('--jhm-overflow-left', '0px');
      var panel = overflow.shadowRoot && overflow.shadowRoot.querySelector('[part="overflow"]');
      var width = panel ? panel.getBoundingClientRect().width : 0;
      if (!width) return;

      var offsetParent = panel.offsetParent;
      if (!offsetParent) return;

      var left = moreRect.left;
      if (left + width > bounds.right) left = bounds.right - width;
      if (left < bounds.left) left = bounds.left;

      overflow.style.setProperty(
        '--jhm-overflow-left',
        Math.round(left - offsetParent.getBoundingClientRect().left) + 'px'
      );

      var v = verticalOffsets(moreRect, header, offsetParent);
      overflow.style.setProperty('--jhm-overflow-top', v.top + 'px');
      overflow.style.setProperty('--jhm-overflow-offset', v.offset + 'px');
    }

    function alignAll() {
      var panels = document.querySelectorAll(PANEL);
      for (var i = 0; i < panels.length; i++) align(panels[i]);
      alignOverflow();
    }

    var raf;
    function schedule() {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(alignAll);
    }

    // Hover anında yeniden ölç: overflow-list öğeleri taşıdığında ya da
    // yazı tipi geç yüklendiğinde ilk hesap bayatlamış olabilir.
    document.addEventListener(
      'pointerenter',
      function (e) {
        var t = e.target;
        if (!t || t.nodeType !== 1 || typeof t.matches !== 'function') return;
        if (!t.matches('.menu-list__list-item:not([slot="overflow"])')) return;
        var panel = t.querySelector(':scope > .menu-list__submenu');
        if (panel) align(panel);
      },
      true
    );

    document.addEventListener(
      'pointerenter',
      function (e) {
        var t = e.target;
        if (t && t.nodeType === 1 && typeof t.matches === 'function' && t.matches('[slot="more"]')) alignOverflow();
      },
      true
    );

    document.addEventListener('focusin', function (e) {
      var li = e.target && e.target.closest && e.target.closest('.menu-list__list-item:not([slot="overflow"])');
      if (!li) return;
      var panel = li.querySelector(':scope > .menu-list__submenu');
      if (panel) align(panel);
    });

    if (document.readyState !== 'loading') schedule();
    else document.addEventListener('DOMContentLoaded', schedule);

    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    function applyAll() {
      document.querySelectorAll('.accelerated-checkout-block[data-custom-buy-now]').forEach(function (el) {
        var label = el.getAttribute('data-custom-buy-now');
        if (!label) return;
        var btn = el.querySelector('.shopify-payment-button__button--unbranded');
        if (btn && btn.textContent.trim() !== label) {
          btn.textContent = label;
        }
      });
    }
    applyAll();
    [300, 800, 1500, 3000].forEach(function (t) { setTimeout(applyAll, t); });
    if ('MutationObserver' in window) {
      new MutationObserver(applyAll).observe(document.documentElement, { childList: true, subtree: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
